import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpAgency'

// LIST ALL Target Workflow
export const workflowList = (params = '') => Http.get(`/workflow-mundo-indie-stages${serialize(params)}`)
export const workflowCreate = (params = '') => Http.post('/workflow-mundo-indie-stages', params)
export const workflowByID = (params = '') => Http.get(`/workflow-mundo-indie-stages/${params}`)
export const workflowUpdate = (params = '') => Http.put(`/workflow-mundo-indie-stages/${params.id}`, params)
export const workflowDestroy = (params = '') => Http.delete(`/workflow-mundo-indie-stages/${params.id}`)
